import {
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { styled } from "@mui/material/styles";
export const PopoverContent = styled(Stack)(({ theme }) => ({
  width: 340,
  padding: theme.spacing(2),
  gap: theme.spacing(1.5),
}));

export const Header = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(0.5),
}));

export const InfoIconWrapper = styled("span")(({ theme }) => ({
  display: "inline-flex",
  color: theme.palette.text.secondary,
}));

export const ToggleGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  gap: theme.spacing(0.75),

  "& .MuiToggleButtonGroup-grouped": {
    border: 0,
    borderRadius: "999px !important",
    margin: 0,
  },
}));

export const PillButton = styled(ToggleButton)(({ theme }) => ({
  height: 30,
  minWidth: 44,
  padding: theme.spacing(0, 1.25),
  borderRadius: 999,
  textTransform: "none",
  whiteSpace: "nowrap",
}));

export const CustomRow = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  flexWrap: "wrap",
  gap: theme.spacing(1),
}));

export const CustomInputRow = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(1),
}));

export const CustomTextField = styled(TextField)(({ theme }) => ({
  width: 110,

  "& .MuiInputBase-root": {
    height: 32,
    fontSize: 13,
    paddingLeft: theme.spacing(0.8),
  },

  ".MuiInputAdornment-root": {
    marginRight: theme.spacing(0.3),

    "& > p": {
      fontSize: 13,
    },
  },
}));
